import type { JSX } from 'react';
import { LegalPage } from './LegalPage';

export function Privacy(): JSX.Element {
  return <LegalPage slug="privacy" />;
}

export default Privacy;
